'use strict';

require('./ReportAdmin.scss');

const React = require('react'),
  {t} = require('services/i18nextWrapper'),
    {map} = require('lodash/collection'),
  SessionStore = require('stores/SessionStore'),
    BoxSelector = require('components/BoxSelector/BoxSelector');

const ReportAdmin = React.createClass({displayName: "ReportAdmin",

    getInitialState() {
        return {};
    },

    render() {
  
      const permissions = SessionStore.getUserPermissions()
      .map(permission => permission.name);
      const ALL_REPORT = [
        {
          title: t('report_general_by_product'),
          imageSrc: 'https://d1nhio0ox7pgb.cloudfront.net/_img/g_collection_png/standard/256x256/package.png',
          style: {fontSize: '10px', backgroundColor: 'red !important'},
          permission: 'ADMIN_REPORT_BY_PRODUCT',
          link: '/#/reports/by-products'
        },
        {
          title: t('report_general_by_task'),
          imageSrc: 'https://cdn3.iconfinder.com/data/icons/hotel-restaurant-flat-vol-3/150/clipboard__checklist__tasklist__document-512.png',
          style: {},
          permission: 'ADMIN_REPORT_BY_TASK',
          link: '/#/reports/by-tasks'
        },
        {
          title: t('report_general_by_item_transaction'),
          imageSrc: 'https://cdn3.iconfinder.com/data/icons/hotel-restaurant-flat-vol-3/150/clipboard__checklist__tasklist__document-512.png',
          style: {},
          permission: 'ADMIN_REPORT_BY_ITEM_TRANSACTION',
          link: '/#/reports/by-item-transaction'
        },
        {
          title: t('report_general_by_batch_number'),
          imageSrc: 'https://cdn3.iconfinder.com/data/icons/hotel-restaurant-flat-vol-3/150/clipboard__checklist__tasklist__document-512.png',
          style: {},
          permission: 'ADMIN_REPORT_BY_BATCH_NUMBER',
          link: '/#/reports/by-batch-number'
        }
      ].filter(report => {
        return permissions.some( userPermission => userPermission === report.permission);
      });
  
      const reportsEl = map(ALL_REPORT, module => React.createElement(BoxSelector, {
                imageSrc: module.imageSrc, 
                title: module.title, 
                stlye: module.style, 
                link: module.link}
            )
        );

        return (
            React.createElement("div", {className: "report-admin"}, 
                React.createElement("div", {className: "report-admin__header"}, t('report_general_select_report')), 
                React.createElement("div", {className: "report-admin__body"}, 
                    reportsEl
                )
            )
        );
    }
});

module.exports = ReportAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/ReportAdmin/ReportAdmin.jsx
 **/